import { backendVersion } from "@/axios-path.js";

export default {
  namespaced: true,
  state: {
    pointManageData: {
      user_points: [],
      user_point_exchanges: []
    },
  },
  mutations: {
    setPointManageData(state, data) {
      state.pointManageData = data.data
      state.pointManageData.user_point_exchange_ranged = data.user_point_exchange_ranged
      state.pointManageData.user_point_ranged = data.user_point_ranged
    },
    setMorePoint(state, data) {
      state.pointManageData.user_points.push(...data.user_points)
    },
    setMorePointExchanged(state, data) {
      state.pointManageData.user_point_exchanges.push(...data.user_point_exchanges)
    }
  },
  actions: {
    async getPointManageData({ commit, dispatch }, { configPath, type, isFirsttime }) {
      let url = `${backendVersion.version}/AllPointByUserTel/${configPath.tel}/${configPath.countPoint}/${configPath.countPointExchange}`;
      let res = await dispatch("fetchGeneral/coreInstanceGetData", url, {
        root: true,
      });
      if (typeof res == "boolean" && res == false) {
        return {};
      } else {
        if (res.msg === true) {
          if (isFirsttime == true) {
            commit("setPointManageData", res);
          } else {
            if (type == "point") {
              commit("setMorePoint", res.data)
            } else if (type == "exchanged") {
              commit("setMorePointExchanged", res.data)
            }
          }
          return res;
        } else {
          return [];
        }
      }
    },
  },
  getters: {},
};
